import React from "react";
import {
  findMatchRanges,
  getSearchTerms,
  isSearchQuery,
} from "../../RentmatchAcademy.search";
import * as S from "./AcademyHighlight.styles";

interface IAcademyHighlightProps {
  text: string;
  // The search the broker came from; without one the text shows as is.
  query?: string;
}

// The text with every word of the query marked, found the way the search finds
// it: without regard to case or accents.
export const AcademyHighlight = ({ text, query }: IAcademyHighlightProps) => {
  if (!query || !isSearchQuery(query)) {
    return <>{text}</>;
  }
  const ranges = findMatchRanges(text, getSearchTerms(query));
  if (ranges.length === 0) {
    return <>{text}</>;
  }

  const parts: React.ReactNode[] = [];
  let cursor = 0;
  ranges.forEach(([start, end]) => {
    if (start > cursor) {
      parts.push(text.slice(cursor, start));
    }
    parts.push(<S.Mark key={start}>{text.slice(start, end)}</S.Mark>);
    cursor = end;
  });
  if (cursor < text.length) {
    parts.push(text.slice(cursor));
  }

  return <>{parts}</>;
};
